import { withSessionStorage, withStorageSync } from '@angular-architects/ngrx-toolkit'; // docs: https://github.com/angular-architects/ngrx-toolkit
import { signalStore, withState } from '@ngrx/signals';

import { withQuoteFormOptionsMethods } from 'app/home/global-store/quote-form-options/effects/quote-form-options.methods';
import { quoteFormOptionsInitialState } from 'app/home/global-store/quote-form-options/quote-form-options-initial-state';
import { withQuoteFormOptionsSelectors } from 'app/home/global-store/quote-form-options/selectors/quote-form-options.selectors';

export const QuoteFormOptionsStore = signalStore(
  { providedIn: 'root' },
  withState(quoteFormOptionsInitialState),
  withQuoteFormOptionsSelectors(),
  withQuoteFormOptionsMethods(),
  withStorageSync(
    {
      key: 'options',
      autoSync: true,
    },
    withSessionStorage(),
  ),
);
